import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'progress-timer',
  templateUrl: './progress-timer.component.html',
  styleUrls: ['./progress-timer.component.css']
})
export class ProgressTimerComponent implements OnInit {

  public text:string;
  
  constructor() { }

  ngOnInit() {
  }

}
